import * as React from "react";
import {
  TextField,
  BooleanField,
  ImageField,
  Show,
  NumberField,
  usePermissions,
  useRecordContext,
  Title,
} from "react-admin";
import { ROLE_TYPES } from "../enums/Roles";
import { SimpleShowLayout } from "../common/SimpleShowLayout";

const CategoryTitle = () => {
  const record = useRecordContext();
  return <Title title={`Categoría "${record?.name}"`} />;
};

const CategoryShow = () => {
  const { permissions } = usePermissions();
  return (
    <Show title={<CategoryTitle />}>
      <SimpleShowLayout>
        {permissions === ROLE_TYPES.ADMIN && (
          <TextField source="id" label="ID" />
        )}
        <TextField source="name" label="Nombre" />
        <ImageField source="image" label="Imagen" />
        <NumberField source="order" label="Orden" />
        <BooleanField source="visible" label="Visible" />
        <BooleanField source="active" label="Activo" />
      </SimpleShowLayout>
    </Show>
  );
};

export default CategoryShow;
